module.exports = __webpack_public_path__ + "static/media/woman-fade.601f9365.jpg";